/**
 * Contact Form 7 デバッグ・エラーハンドリング
 *
 * フォーム送信時のエラーを詳細にログ出力し、問題の特定を支援します。
 */
const contactForm7Debug = () => {
  // フォーム送信前のバリデーションエラー
  document.addEventListener('wpcf7invalid', function (event) {
    console.error('Contact Form 7: バリデーションエラー', event.detail);
  });

  // メール送信失敗
  document.addEventListener('wpcf7mailfailed', function (event) {
    console.error('Contact Form 7: メール送信失敗', event.detail);
  });

  // スパム検出
  document.addEventListener('wpcf7spam', function (event) {
    console.error('Contact Form 7: スパム検出', event.detail);
  });

  // 送信開始
  document.addEventListener('wpcf7submit', function (event) {
    console.log('Contact Form 7: 送信開始', event.detail);
  });

  // 送信成功
  document.addEventListener('wpcf7mailsent', function (event) {
    console.log('Contact Form 7: メール送信成功', event.detail);
  });
};

export { contactForm7Debug };
